import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { CSInputComponent } from 'src/app/shared/components/cs-input/cs-input.component';
import { EncryptService } from 'src/app/shared/service/encrypt.service';
import { ValidatorService } from 'src/app/shared/service/validator.service';
import { LoginService } from '../login.service';
@Component({
  standalone: true,
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  imports: [CSButtonComponent, CSIconButtonComponent, CSInputComponent, FormsModule, ReactiveFormsModule],
})
export class ResetPasswordComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ResetPasswordComponent>,
    private encryptService: EncryptService,
    public loginService: LoginService,
  ) {}

  public passwordType: 'password' | 'text' = 'password';
  public confirmPasswordType: 'password' | 'text' = 'password';

  public isDirty: boolean = false;

  public loading: boolean = false;

  public form: FormGroup = new FormGroup({
    password: new FormControl('', { validators: [ValidatorService.passwordStrengthValidator(), Validators.required] }),
    confirmPassword: new FormControl('', {
      validators: [ValidatorService.matchValidator('password'), Validators.required],
    }),
  });

  get pwdErrors() {
    return this.form.controls['password'].errors || {};
  }

  get confirmPwdErrors() {
    return this.form.controls['confirmPassword'].errors || {};
  }

  @HostListener('document:keydown.enter', ['$event'])
  public onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !this.submitDisabled) {
      this.submit();
    }
  }

  ngOnInit(): void {
    this.form.valueChanges.subscribe(() => {
      this.isDirty = true;
    });
    this.form.get('password')?.valueChanges.subscribe(() => {
      this.form.get('confirmPassword')?.updateValueAndValidity();
    });
  }

  public onPasswordClick() {
    if (this.passwordType === 'password') {
      this.passwordType = 'text';
    } else {
      this.passwordType = 'password';
    }
  }

  public onConfirmPasswordClick() {
    if (this.confirmPasswordType === 'password') {
      this.confirmPasswordType = 'text';
    } else {
      this.confirmPasswordType = 'password';
    }
  }

  get submitDisabled(): boolean {
    return (
      (this.form.invalid && this.isDirty) ||
      this.form.controls['password'].value === '' ||
      this.form.controls['confirmPassword'].value === ''
    );
  }

  async submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading = true;
    try {
      const password = this.encryptService.encrypt(this.form.value.password);
      await this.loginService.handleResetPassword(password, this.loginService.uniCode);
    } catch (error) {
      console.error(error);
    }
    this.loading = false;
  }

  close(): void {
    this.dialogRef.close();
  }
}
